import * as React from 'react';
import './EventChangeNotices.scss';

interface Props {
  latestChange?: string;
  cancellationReason?: string;
}

const NoticeIcon = ({ type }: { type: 'change' | 'cancellation' }) => (
  <svg
    viewBox="0 0 24 24"
    width="17"
    height="17"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {type === 'cancellation' ? (
      <>
        <path d="M12 9v4" />
        <path d="M12 17h.01" />
        <path d="M10.3 3.8 2.5 17.3A2 2 0 0 0 4.2 20h15.6a2 2 0 0 0 1.7-2.7L13.7 3.8a2 2 0 0 0-3.4 0Z" />
      </>
    ) : (
      <>
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4Z" />
      </>
    )}
  </svg>
);

export const EventChangeNotices = ({ latestChange = '', cancellationReason = '' }: Props) => {
  const latestChangeText = String(latestChange || '').trim();
  const cancellationReasonText = String(cancellationReason || '').trim();

  if (!latestChangeText && !cancellationReasonText) return null;

  return (
    <div className="eventChangeNotices" role="note" aria-label="Event updates">
      {cancellationReasonText ? (
        <div className="eventChangeNotice eventChangeNotice--cancellation">
          <span className="eventChangeNotice__icon">
            <NoticeIcon type="cancellation" />
          </span>
          <div className="eventChangeNotice__content">
            <div className="eventChangeNotice__label">Cancellation reason</div>
            <div className="eventChangeNotice__text">{cancellationReasonText}</div>
          </div>
        </div>
      ) : null}

      {latestChangeText ? (
        <div className="eventChangeNotice eventChangeNotice--change">
          <span className="eventChangeNotice__icon">
            <NoticeIcon type="change" />
          </span>
          <div className="eventChangeNotice__content">
            <div className="eventChangeNotice__label">Latest change</div>
            <div className="eventChangeNotice__text">{latestChangeText}</div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

EventChangeNotices.displayName = 'EventChangeNotices';
